<ng-container [ngSwitch]="eventType">

    <div *ngSwitchCase="'app-integration-add'">
        You linked the {{ eventItem.items.app_name }} app
    </div>

    <div *ngSwitchCase="'app-integration-remove'">
        You removed the {{ eventItem.items.app_name }} app
    </div>

    <div *ngSwitchCase="'auth-login-2fa-incorrect'">
        An incorrect response to a two-factor authentication request was received by
        {{ eventItem.items.ipaddr }} with {{ eventItem.items.browser }} ({{
        eventItem.items.platform
        }})
    </div>

    <div *ngSwitchCase="'auth-login-2fa-prompted'">
        A two-factor authentication request was received by
        {{ eventItem.items.ipaddr }} with {{ eventItem.items.browser }} ({{
        eventItem.items.platform
        }})
    </div>

    <div *ngSwitchCase="'auth-login-fail'">
        A failed log in was recorded from {{ eventItem.items.ipaddr }} with
        {{ eventItem.items.browser }} ({{ eventItem.items.platform }})
    </div>

    <div *ngSwitchCase="'auth-login-success'">
        You successfully logged in from {{ eventItem.items.ipaddr }} with
        {{ eventItem.items.browser }} ({{ eventItem.items.platform }})
    </div>

    <div *ngSwitchCase="'auth-user-backup-code-consume'">
        A two-factor authentication back-up code has been consumed from
        {{ eventItem.items.ipaddr }} with
        {{ eventItem.items.browser }}
    </div>

    <div *ngSwitchCase="'auth-user-backup-code-create'">
        You generated 10 two-factor authentication back-up codes from
        {{ eventItem.items.ipaddr }} with
        {{ eventItem.items.browser }}
    </div>

    <div *ngSwitchCase="'email-notification-changed'">
        You
        <span *ngIf="eventItem.items.action === 'add'">opted in</span>
        <span *ngIf="eventItem.items.action === 'remove'">opted out</span>
        for {{ eventItem.items.email_type }} emails.
    </div>

    <div *ngSwitchCase="'link-comment-create'">
        {{ eventItem.items.author }} added a comment on your link:
        <span class="event-item-name">{{ eventItem.items.linkname }}</span> from
        {{ eventItem.items.ipaddr }}
    </div>

    <div *ngSwitchCase="'link-comment-delete'">
        {{ eventItem.items.author }} deleted a comment on your link:
        <span class="event-item-name">{{ eventItem.items.linkname }}</span> from
        {{ eventItem.items.ipaddr }}
    </div>

    <div *ngSwitchCase="'link-comment-update'">
        {{ eventItem.items.author }} updated a comment on your link:
        <span class="event-item-name">{{ eventItem.items.linkname }}</span> from
        {{ eventItem.items.ipaddr }}
    </div>


    <div *ngSwitchCase="'link-create'">
        You created the link
        <a class="syncblue" [hidden]="!syncPid" [routerLink]="[stateref, syncPid]" [queryParams]="stateParams"
            target="{{ stateTarget }}" [innerHtml]="eventItem.items.name"></a>
        <span [hidden]="syncPid" [innerHtml]="eventItem.items.name" class="event-item-name"></span>
    </div>

    <div *ngSwitchCase="'link-delete'">
        You deleted the link
        <a class="syncblue" [hidden]="!syncPid" [routerLink]="[stateref, syncPid]" [queryParams]="stateParams"
            target="{{ stateTarget }}" [innerHtml]="eventItem.items.name"></a>
        <span [hidden]="syncPid" [innerHtml]="eventItem.items.name" class="event-item-name"></span>
    </div>

    <div *ngSwitchCase="'link-download'">
        Your link
        <span class="event-item-name">{{ eventItem.items.name }}</span>
        was downloaded by {{ eventItem.items.ipaddr }}
    </div>

    <div *ngSwitchCase="'link-send-url'">
        Your link
        <span [innerHtml]="eventItem.items.name" class="event-item-name"></span> was
        sent to
        <span [innerHtml]="eventItem.items.recipientEmail | b64"></span>
    </div>

    <div *ngSwitchCase="'link-upload'">
        A file has been uploaded to your link
        <span [innerHtml]="eventItem.items.name" class="event-item-name"></span>
        by someone at {{ eventItem.items.ipaddr }}
    </div>

    <div *ngSwitchCase="'link-edit'">
        {{ eventItem.items.user_email | b64 }} updated
        <!-- if sync_id is available, link is to a file -->
        <!-- hence, filename will be available in the enc_meta_name -->
        <span *ngIf="eventItem.items.sync_id">
            <a [innerHtml]="eventItem.items.name" class="syncblue event-item-name"
                [routerLink]="['/file', eventItem.items.sync_id, 'view', 'doc']" target="{{ stateTarget }}"></a>
        </span>
        <!-- if sync_pid is available, link is to a folder -->
        <!-- hence, folder name will be available in the enc_meta_name -->
        <!-- and filename will be explicitly added -->
        <span *ngIf="eventItem.items.sync_pid">
            [{{ eventItem.items.filename| b64 }}] in
            <a [innerHtml]="eventItem.items.name" class="syncblue event-item-name"
                [routerLink]="[stateref, eventItem.items.sync_pid]" target="{{ stateTarget }}"></a>
        </span>
        via a <a (click)="openLinkDialog()" class="syncblue showhand underline"> Link </a>
    </div>

    <div *ngSwitchCase="'migrate-done'">
        <span *ngIf="eventItem.items.jobstatus === 5 && !isOverQuota">
            Your
            <span *ngIf="eventItem.items.jobtype === 'dropbox'">Dropbox</span>
            <span *ngIf="eventItem.items.jobtype !== 'dropbox'">[unknown type]</span>
            file migration
            <span *ngIf="eventItem.items.hasfailedfiles === 0">has completed!</span>
            <span *ngIf="eventItem.items.hasfailedfiles !== 0">has completed, but with failed files!</span>
        </span>
        <span *ngIf="eventItem.items.jobstatus === 5 && isOverQuota">
            Your
            <span *ngIf="eventItem.items.jobtype === 'dropbox'">Dropbox</span>
            <span *ngIf="eventItem.items.jobtype !== 'dropbox'">[unknown type]</span>
            file import did not complete, because your account doesn't have enough
            space. Please
            <a (click)="openPortal()" class="syncblue showhand">upgrade</a> your
            account and try again.
        </span>
        <span *ngIf="eventItem.items.jobstatus === 6">
            Migration failed due to internal errors!
        </span>
        <span *ngIf="eventItem.items.jobstatus === 7">
            Couldn't import file due to authorization errors!
        </span>
        <span *ngIf="eventItem.items.jobstatus === 8">
            File migration was cancelled!
        </span>
        <span *ngIf="eventItem.items.jobstatus === 9">
            Couldn't start your
            <span *ngIf="eventItem.items.jobtype === 'dropbox'">Dropbox</span>
            <span *ngIf="eventItem.items.jobtype !== 'dropbox'">[unknown type]</span>
            migration since your account does not have enough free space. (required
            space: {{ eventItem.items.extra.total_bytes | bytesToSize }}) Please
            <a (click)="openPortal()" class="syncblue showhand">upgrade</a> your
            account to a premium plan.
        </span>
    </div>

    <div *ngSwitchCase="'account-migrated'">
        <span class="event-item-name"> Your account migrated to {{ eventItem.items.invited_by_email }}'s team</span>
    </div>

    <div *ngSwitchCase="'migrate-started'">
        Your
        <span *ngIf="eventItem.items.jobtype === 'dropbox'"> Dropbox </span>
        <span *ngIf="eventItem.items.jobtype !== 'dropbox'"> [unknown type] </span>
        file migration has started!
    </div>

    <div *ngSwitchCase="'password-reset-changed'">
        Password reset was
        <span [innerHtml]="eventItem.items.enabled === 1 ? 'enabled' : 'disabled'"></span>
        by {{ eventItem.items.ipaddr }} ({{ eventItem.items.browser }})
    </div>

    <div *ngSwitchCase="'password-reset-request'">
        A password reset request was received by {{ eventItem.items.ipaddr }} ({{eventItem.items.browser}})
    </div>

    <div *ngSwitchCase="'password-update-multiuser-child'">
        {{ eventItem.items.parent_email }}
        reset your password from {{ eventItem.items.ipaddr }} on the web ({{eventItem.items.browser}})
    </div>

    <div *ngSwitchCase="'password-update-multiuser-parent'">
        You updated {{ eventItem.items.child_email }} password from
        {{ eventItem.items.ipaddr }} on the web ({{ eventItem.items.browser }})
    </div>

    <div *ngSwitchCase="'password-update'">
        Your password was updated by {{ eventItem.items.ipaddr }}
        <span [hidden]="!(eventItem.items.device_type_name === 'Web' || !eventItem.items.device_type_name)">
            on the web ({{ eventItem.items.browser }})
        </span>
        <span [hidden]="!(eventItem.items.device_type_name !== 'Web') || !eventItem.items.device_name">
            ({{ eventItem.items.device_name }})
        </span>
    </div>


    <div *ngSwitchCase="'path-add-share'">
        {{ getEventActor }} added the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{ last ? "" : index === eventItem.items.pathitems.length - 2 ? ", and " : ", " }}
            </span>
            <span *ngIf="eventItem.items.pathitems_count > 2 && eventItem.items.pathitems_count >= eventItem.items.pathitems.length">
                and
                <span [innerHtml]="eventItem.items.pathitems_count - 2"></span>
                more files
            </span>
        </a>
        in
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>
        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
    </div>

    <div *ngSwitchCase="'path-add'">
        {{ getEventActor }}
        added the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2); let index = index; let last = last
            ">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{last? "": index === eventItem.items.pathitems.length - 2? ", and ": ","}}
            </span>
            <span *ngIf="eventItem.items.pathitems_count>2 && eventItem.items.pathitems_count >= eventItem.items.pathitems.length"> 
                and
                <span [innerHtml]="eventItem.items.pathitems_count - 2"></span>
                more files
            </span>
        </a>
    </div>

    <div *ngSwitchCase="'path-deleted-share'">
        {{ getEventActor }}
        deleted the shared
        <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>
        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{ last ? "" : index === eventItem.items.pathitems.length - 2 ? ", and " : ", " }}
            </span>
            <span *ngIf=" eventItem.items.pathitems_count > pathListLimit">
                and
                <span [innerHtml]="eventItem.items.pathitems_count - 2"></span>
                more files
            </span>
        </a>
        in
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>
        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>
        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
    </div>

    <div *ngSwitchCase="'path-deleted'">
        {{ getEventActor }}
        deleted the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{ last ? "" : index === eventItem.items.pathitems.length - 2 ? ", and " : ", " }}
            </span>
            <span *ngIf="eventItem.items.pathitems_count > pathListLimit">
                and
                <span [innerHtml]="eventItem.items.pathitems_count - 2"></span>
                more files
            </span>
        </a>
    </div>

    <div *ngSwitchCase="'path-edited-share'">
        {{ getEventActor }}
        updated the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{ last ? "" : index === eventItem.items.pathitems.length - 2 ? ", and " : ", "}}
            </span>
            <span *ngIf=" eventItem.items.pathitems_count > pathListLimit">
                and
                <span [innerHtml]="eventItem.items.pathitems_count - 2"></span>
                more files
            </span>
        </a>
        in
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>
        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
    </div>

    <div *ngSwitchCase="'path-edited'">
        {{ getEventActor }}
        updated the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let last = last; let index = index">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{last ? "" : index === eventItem.items.pathitems.length - 2 ? ", and " : ", "}}
            </span>
            <span *ngIf=" eventItem.items.pathitems_count > pathListLimit">
                and
                <span [innerHtml]="eventItem.items.pathitems_count - 2"></span>
                more files
            </span>
        </a>
    </div>

    <div *ngSwitchCase="'path-move-share'">
        {{ getEventActor }}
        moved the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{last? "": index === eventItem.items.pathitems.length - 2? ", from ": ", "}}
            </span>
        </a>
        in
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>
        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>
        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
    </div>

    <div *ngSwitchCase="'path-move'">
        {{ getEventActor }}
        moved the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{ last ? "" : index === eventItem.items.pathitems.length - 2 ? ", from " : ", " }}
            </span>
        </a>
    </div>

    <div *ngSwitchCase="'path-purge-share'">
        {{ getEventActor }}
        purged the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{ last ? "" : index === eventItem.items.pathitems.length - 2 ? ", and " : ", " }}
            </span>
            <span *ngIf=" eventItem.items.pathitems_count > pathListLimit">
                and
                <span [innerHtml]="eventItem.items.pathitems_count - 2"></span>
                more files
            </span>
        </a>
        in
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>

        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
    </div>

    <div *ngSwitchCase="'path-purge'">
        {{ getEventActor }}
        purged the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{ last ? "" : index === eventItem.items.pathitems.length - 2 ? ", and " : ", " }}
            </span>
            <span *ngIf=" eventItem.items.pathitems_count > pathListLimit">
                and
                <span [innerHtml]="eventItem.items.pathitems_count - 2"></span>
                more files
            </span>
        </a>
    </div>

    <div *ngSwitchCase="'path-rename-share'">
        {{ getEventActor }}
        renamed the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{ last ? "" : index === eventItem.items.pathitems.length - 2 ? ", from " : ", " }}
            </span>
        </a>
        in
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>

        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
    </div>

    <div *ngSwitchCase="'path-rename'">
        {{ getEventActor }}
        renamed the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{ last ? "" : index === eventItem.items.pathitems.length - 2 ? ", from " : ", " }}
            </span>
        </a>
    </div>

    <div *ngSwitchCase="'path-restore-share'">
        {{ getEventActor }}
        restored the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{ last ? "" : index === eventItem.items.pathitems.length - 2 ? ", and " : ", " }}
            </span>
            <span *ngIf="eventItem.items.pathitems_count > pathListLimit">
                and
                <span [innerHtml]="eventItem.items.pathitems_count - 2"></span>
                more files
            </span>
        </a>
        in
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>

        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
    </div>

    <div *ngSwitchCase="'path-restore'">
        {{ getEventActor }}
        restored the <span [innerHtml]="getIsFolder ? 'folder ' : 'file '"></span>

        <a 
            (click)="openEventDetails()" class="syncblue hand underline">
            <span *ngFor=" let pathitem of eventItem.items.pathitems.slice(0, 2) let index = index; let last = last">
                <span [innerHtml]="pathitem.name" class="event-item-name"></span>
                {{ last ? "" : index === eventItem.items.pathitems.length - 2 ? ", and " : ", " }}
            </span>
            <span *ngIf=" eventItem.items.pathitems_count > pathListLimit">
                and
                <span [innerHtml]="eventItem.items.pathitems_count - 2"></span>
                more files
            </span>
        </a>
    </div>

    <div *ngSwitchCase="'provision-device'">
        You installed the
        <span [innerHtml]="eventItem.items.devicetype_name"></span> device
        <span [innerHtml]="eventItem.items.device_name | b64"></span> from the ip
        <span [innerHtml]="eventItem.items.ipaddr"></span>
    </div>

    <div *ngSwitchCase="'provision-user'">
        You joined Sync from the ip
        <span [innerHtml]="eventItem.items.ipaddr"></span>, welcome!
    </div>

    <div *ngSwitchCase="'rewind-dir'">
        You Rewinded the dir
        <span [innerHtml]="eventItem.items.sync_pid"></span>
        <span [innerHtml]="eventItem.items.name"></span>
        to the date
        <span [innerHtml]="eventItem.items.servtime | date: 'medium'"></span>
    </div>

    <div *ngSwitchCase="'share-accept-owner'">
        <span [innerHtml]="eventItem.items.invitee_email"></span>
        joined the share

        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>
        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
        <span [hidden]="!(eventItem.items.permission.indexOf('perSEEOTHERS') > -1)">
            created by
            <span [hidden]="!(eventItem.items.inviter_user_id !== eventItem.user_id)"
                [innerHtml]="eventItem.items.inviter_display_name"></span>
            <span [hidden]="!(eventItem.items.inviter_user_id === eventItem.user_id)">
                you</span>
        </span>
    </div>

    <div *ngSwitchCase="'share-accept-user'">
        You joined
        <span [innerHtml]="eventItem.items.inviter_display_name | b64"></span>'s
        share
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>

        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>

        <span [hidden]="!(eventItem.items.permission.indexOf('perSEEOTHERS') > -1)">
            by
            <span [hidden]="!(eventItem.items.inviter_user_id !== eventItem.user_id)"
                [innerHtml]="eventItem.items.inviter_display_name | b64"></span>
            <span [hidden]="!(eventItem.items.inviter_user_id === eventItem.user_id)">
                you</span>
        </span>
    </div>

    <div *ngSwitchCase="'share-create'">
        You created the share
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>

        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
    </div>

    <div *ngSwitchCase="'share-invite-owner'">
        <span [innerHtml]="eventItem.items.invitee_email"></span>
        was invited to the share
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>

        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
        created by
        <span [hidden]="!(eventItem.items.inviter_user_id !== eventItem.user_id)"
            [innerHtml]="eventItem.items.inviter_display_name | b64"></span>
        <span [hidden]="!(eventItem.items.inviter_user_id === eventItem.user_id)">
            you</span>
    </div>

    <div *ngSwitchCase="'share-invite-user'">
        You were invited to
        <span [innerHtml]="eventItem.items.inviter_display_name | b64"></span>'s
        share
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>

        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>

        <span [hidden]="!(eventItem.items.permission.indexOf('perSEEOTHERS') > -1)">
            by
            <span [hidden]="!(eventItem.items.inviter_user_id !== eventItem.user_id)"
                [innerHtml]="eventItem.items.inviter_display_name | b64"></span>

            <span [hidden]="!(eventItem.items.inviter_user_id === eventItem.user_id)">
                you</span>
        </span>
    </div>

    <div *ngSwitchCase="'share-leave-owner'">
        <span [innerHtml]="eventItem.items.invitee_display_name | b64"></span>
        ( <span [innerHtml]="eventItem.items.invitee_email"></span> ) left your
        share
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>

        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
    </div>

    <div *ngSwitchCase="'share-leave-user'">
        You left
        <span [innerHtml]="eventItem.items.inviter_display_name | b64"></span>'s
        share
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>

        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
    </div>

    <div *ngSwitchCase="'share-remove-owner'">
        <span [innerHtml]="eventItem.items.invitee_email"></span>
        was removed from your share
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>
        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
        <span *ngIf="eventItem.items.purge === 1"> with <I>Remote Wipe</I></span>
    </div>

    <div *ngSwitchCase="'share-ownership-transfered'">
        You transferred ownership of the share

        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName | b64"></a>
        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.name)"
            [innerHtml]="eventItem.items.name | b64"></span>
        to
        <b><span>
                {{eventItem.items.new_owner_email}}
            </span></b>
    </div>

    <div *ngSwitchCase="'share-promoted-as-owner'">
        Ownership of the share

        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName | b64"></a>
        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>

        <span [hidden]="!(!syncPid && !shareName && eventItem.items.name)"
            [innerHtml]="eventItem.items.name | b64"></span>
        has been transferred to you by
        <b><span>{{eventItem.items.old_owner_email}}</span></b>
    </div>

    <div *ngSwitchCase="'share-remove-user'">
        You were removed from
        <span [innerHtml]="eventItem.items.actor_display_name | b64"></span>'s share
        <a class="syncblue" [hidden]="!(syncPid && shareName)" [routerLink]="[stateref, syncPid]"
            [queryParams]="stateParams" target="{{ stateTarget }}" [innerHtml]="shareName"></a>
        <span [hidden]="!(!syncPid && shareName)" [innerHtml]="shareName"></span>
        <span [hidden]="!(!syncPid && !shareName && eventItem.items.label)"
            [innerHtml]="eventItem.items.label | b64"></span>
    </div>

    <div *ngSwitchCase="'upgrade-device'">
        You upgraded the
        <span [innerHtml]="eventItem.items.devicetype_name"></span> device
        <span [innerHtml]="eventItem.items.device_name"></span> to version
        <span [innerHtml]="eventItem.items.new_version"></span>
    </div>

    <div *ngSwitchCase="'username-changed'">
        Your username was updated by {{ eventItem.items.ipaddr }}
        from
        {{ eventItem.items.old_email }}
        to
        {{ eventItem.items.new_email }}
    </div>


    <div *ngSwitchDefault>-- {{eventType}}</div>
</ng-container>

<div class="permissionsDialogBody">
    <sync-dialog
      [config]="{
        title: popupTitle,
        subTitle: popupAltSubTitle,
        subTitle2: popupSubTitle,
        onCancelClick: onClose,
        isClosable: true,
        closeIcon: 'close'
      }"
      [onClose]="onClose"
      [open]="popupIsOpen"      
      [hideDialogFooter]="true"
    >
    <app-activity-log-detail class="event-details" *ngIf="popupIsOpen"  [eventId]="popupEventId" [onLoad]="onActivityLogLoad"></app-activity-log-detail>
    </sync-dialog>
  </div>
  
<ng-template #dialoglinkcontent>
    <app-dialog-link [item]="linkItem" [openState]="openState"></app-dialog-link>
</ng-template>